import {
  ArtifactConsentDocumentV1,
  AnsweredConsentStatusTypeV1,
  ConsentFormV1,
  ConsentTypeV1,
  ArtifactV1,
} from '@csp/dto';
import { ConsentApprovalV1 } from '@csp/dmdp-api-consent-dto';
import { ConsentRequest } from './ConsentRequest';

export type AnsweredConsentRequest = ConsentRequest & {
  /** optional approval: if the consent is not mandatory and declined, then it has no approval entity associated with it */
  approval: ConsentApprovalV1 | null;
  /** time when the consent was declined (in client-side only, as the Boost API model does not include declined consents at the moment) */
  skippedAt: string | null;
};

export type AnsweredLegacyConsent = ConsentFormV1 & {
  /** optional approval: only in theory, as all legacy consents should be mandatory (in practice) */
  approval: ConsentApprovalV1 | null;
};

export type SkippedConsent = {
  artifactCode: string;
  skippedAt: string;
};

/**
 * Represent a formatted date like `2021-01-08T14:42:34.678Z` (format: ISO_8601).
 * @see https://en.wikipedia.org/wiki/ISO_8601
 */
export type ISO_8601 = string;

/**
 * Interface describing a consent that has been presented to the user
 * which has either approved or declined it (if non mandatory)
 * e.g. not "pending" user approval
 */
export type AnsweredConsentDeprecated = {
  id: string;
  artifact: ArtifactV1;
  approvalId: string | undefined;
  consentStatus: {
    status: AnsweredConsentStatusTypeV1;
    /** if the consent is declined, but we had not stored the timestamp, this timestamp may be empty */
    statusUpdateTimestamp: ISO_8601;
  };
  document: ArtifactConsentDocumentV1;
  mandatory: boolean;
};

/**
 * Type-guard function to differentiate a legacy consent from a regular
 */
export const isLegacyConsent = (
  consent: AnsweredConsentRequest | AnsweredLegacyConsent | null,
): consent is AnsweredLegacyConsent =>
  !!consent && 'config' in consent && 'consentType' in consent && consent.consentType === ConsentTypeV1.CONSENT_FORM_V1;
